import AddCircleButton from '../AddCircleButton';
import { DETAIL_TOKENS } from '../../../styles/UISystem';
import { GroupChip } from '../GroupChip';

/**
 * GroupsSection — shared GROUPS section (colored chips + add button) for the
 * Profile and Manual detail pages. The GroupSelector overlay and its onSave stay
 * in each page — they resolve the connection-view id differently.
 *
 * Props:
 *   groups - the connection's assigned group objects
 *   onEdit - opens the page's GroupSelector (chip tap + add button)
 */
const GroupsSection = ({ groups, onEdit }) => (
  <div style={{ width: '100%', maxWidth: DETAIL_TOKENS.SECTION_MAX_WIDTH }}>
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '8px',
        alignItems: 'center',
        // Centred, like every other element in the detail column (frames)
        justifyContent: 'center',
      }}
    >
      {groups.map((group) => (
        <GroupChip key={group.id} group={group} onClick={onEdit} />
      ))}
      {/* Label only when there are no groups yet */}
      <AddCircleButton label="Add group" showLabel={groups.length === 0} onClick={onEdit} />
    </div>
  </div>
);

export default GroupsSection;
